var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-width-3 col-12 mx-auto py3 border-box px2",attrs:{"id":"mybatch_wrapper"}},[_c('Transition',{attrs:{"name":"fade"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }